import * as React from 'react';
import { Progress } from '@repo/ui-web';
import { progressStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

export function ProgressShowcase() {
  const [value, setValue] = React.useState<(typeof progressStates)[number]>(35);

  return (
    <div className="space-y-4">
      <StateToggle
        options={progressStates}
        value={value}
        onChange={setValue}
        label="Value"
        formatLabel={(option) => `${option}%`}
      />
      <div className="space-y-2">
        <Progress value={value} />
        <p className="text-xs text-muted-foreground">{value}% complete</p>
      </div>
    </div>
  );
}
